module.exports = __webpack_public_path__ + "static/media/1012470.3a2a68ed.jpg";